import { Reveal } from "@/components/Reveal";

export default function PageHero({ eyebrow, title, subtitle, image, children }) {
  return (
    <section className="relative overflow-hidden bg-navy pt-36 pb-20 lg:pt-44 lg:pb-28" data-testid="page-hero">
      {image && (
        <>
          <img src={image} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-25" loading="eager" />
          <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/90 to-navy/60" />
        </>
      )}
      <div className="pointer-events-none absolute -right-24 top-10 h-72 w-72 rounded-full bg-ocean/25 blur-3xl" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="max-w-3xl">
          {eyebrow && <span className="eyebrow text-sky" data-testid="page-hero-eyebrow">{eyebrow}</span>}
          <h1 className="mt-4 font-serif text-4xl font-bold leading-tight text-white text-balance sm:text-5xl lg:text-6xl">{title}</h1>
          {subtitle && <p className="mt-6 text-lg leading-relaxed text-white/75">{subtitle}</p>}
          {children && <div className="mt-8">{children}</div>}
        </Reveal>
      </div>
    </section>
  );
}
